import { InstrumentLocation } from '../interfaces';
import * as HttpResponseCodes from './httpResponseCodes';

export const DEFAULT_EMPTY_STRING = '-';
export const DEFAULT_DATE_TIME_FORMAT = 'dd MMM yyyy h:mm a';
export const DEFAULT_DATE_FORMAT = 'MMMM d, yyyy';

export const FORBIDDEN_TITLE = 'QIAsphere account is required';
export const FORBIDDEN_MESSAGE =
  'Sorry, you do not have access to this service. Please contact the administrator of your organization to use QIAsphere.';

export const NOT_FOUND_TITLE = 'Page not found';
export const NOT_FOUND_MESSAGE = 'Sorry, the requested resource is not available on our servers.';
export const SERVICE_UNAUTHORIZED_TITLE = 'Service User unauthorized';
export const SERVICE_UNAUTHORIZED_MESSAGE =
  'Sorry, something went wrong. If you entered correct credentials, please contact QIAsphere Administrator';
export const SERVICE_UNAUTHORIZED_BUTTON = 'Try again';

export const UNAVAILABLE_TITLE = 'Service temporary unavailable';
export const UNAVAILABLE_MESSAGE =
  'Sorry, we are currently experiencing technical difficulties. Please try again later.';

export const EMPTY_INSTRUMENT_LOCATION = {
  additionalInformation: DEFAULT_EMPTY_STRING,
  city: DEFAULT_EMPTY_STRING,
  countryCode: DEFAULT_EMPTY_STRING,
  countryName: DEFAULT_EMPTY_STRING,
  state: DEFAULT_EMPTY_STRING,
  street: DEFAULT_EMPTY_STRING,
  streetNumber: DEFAULT_EMPTY_STRING,
  zipCode: DEFAULT_EMPTY_STRING
} as InstrumentLocation;

export { HttpResponseCodes };
